/**
 * Erro do que o COMPRADOR digitou (cartão vencido, dados do cartão recusados pelo tokenizador).
 * A mensagem vai ao comprador como está; não é falha do servidor nem da nossa lógica, então não vai
 * ao Sentry — `reportCheckoutError` e o `beforeSend` descartam.
 */
export class CheckoutInputError extends Error {
	readonly isCheckoutInputError = true;

	constructor(message: string) {
		super(message);
		this.name = 'CheckoutInputError';
		// O build é ES5: sem isto, `instanceof` falha em subclasse de Error.
		Object.setPrototypeOf(this, CheckoutInputError.prototype);
	}
}

export function isCheckoutInputError(error: unknown): boolean {
	return (
		error instanceof CheckoutInputError ||
		(error as { isCheckoutInputError?: unknown })?.isCheckoutInputError ===
			true
	);
}
